import { MessageSquare } from "lucide-react"

import { CapabilityCard } from "@/components/agents/setup/capability-card"

import type { EditableFields } from "../edit-sheet"

type Update = <K extends keyof EditableFields>(
  key: K,
  value: EditableFields[K],
) => void

// IMP-492: the owner's control over whether the receptionist takes messages,
// changeable after launch. No delivery destination — where a message goes is an
// account-level Notifications setting (IMP-375).
//
// Off doesn't just remove the capability: the agent is told to decline and
// point the caller elsewhere (see Agents::Receptionist::PromptBuilder). Removing
// the tool on its own is what produced IMP-490, where a caller was promised a
// message that no tool would record.
export function MessagesPanel({
  fields,
  onChange,
}: {
  fields: EditableFields
  onChange: Update
}) {
  return (
    <CapabilityCard
      icon={MessageSquare}
      on={fields.messages_enabled}
      title="Take messages"
      description="Takes a name, a way to reach them, and the reason they called. When off, callers are told you can't take messages and pointed to another way to reach the business."
      onToggle={(next) => onChange("messages_enabled", next)}
    />
  )
}
